import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  background-color: ${p => p.theme.colors.white};
  width: 100vw;
  height: auto;
  min-height: 100vh;
  display: flex;
  padding: 102px 0;

  @media (max-width: 768px) {
    padding: 56px 0;
  }

  .identity__page-logo {
    align-self: center;
  }

  .identity__page-heading {
    margin: 56px 0 32px;
    font-size: 20px;
    line-height: 28px;
    color: #00012b;
  }

  .identity__secondary-action {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #373ae5;
    display: flex;
    svg {
      margin-right: 8px;
    }
    &.center {
      align-self: center;
    }
    margin: 0;
  }

  .identity__field {
    margin: 0 0 16px 0;
    &.with-error {
      margin-bottom: 54px;
      border-bottom: none;
      &.password {
        margin-bottom: 24px;
      }
    }

    &:not(.with-error) {
      input {
        &:focus {
          &:not([disabled]) ~ label {
            color: #5d5d5d;
          }
        }
      }

      label {
        color: #5d5d5d;
        font-weight: 400;
      }
    }
  }

  .identity__form-submit {
    margin-bottom: 24px;
    cursor: pointer;
    border-radius: 8px;
    height: 56px;
    span {
      font-size: 16px;
      line-height: 24px;
      color: ${p => p.theme.colors.white};
    }
    &:disabled {
      background: #747474;
      cursor: not-allowed;
    }
    &:not(:disabled) {
      background: linear-gradient(186.76deg, #373ae5 14.16%, #292cb7 48.63%);
    }
  }
`;

type PageLayoutProps = {
  children: React.ReactNode | React.ReactNodeArray;
  title?: string;
  description?: string;
  testId?: string;
};
export const PageLayout = ({ children, title, description, testId }: PageLayoutProps) => {
  useEffect(() => {
    document.querySelector('h1')?.setAttribute('tabindex', '-1');
    document.querySelector('h1')?.focus();
  }, []);
  return (
    <StyledWrapper data-testid={testId}>
      <Helmet>
        {title && <title>MGM Resorts | {title}</title>}
        {description && <meta name='description' content={description} />}
      </Helmet>
      {children}
    </StyledWrapper>
  );
};

PageLayout.displayName = 'PageLayout';
